import { render, staticRenderFns } from "./AlertRuleList.vue?vue&type=template&id=3136cf04&"
import script from "./AlertRuleList.vue?vue&type=script&lang=js&"
export * from "./AlertRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports